
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frequently-asked-question",
      function () {
        return require("private-next-pages/frequently-asked-question.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frequently-asked-question"])
      });
    }
  